import $ from 'jquery';
import ScreenUtils from 'application/screen_utils';
import 'bootstrap/js/modal';
import 'metrics';

class Menu {
  constructor(guia = false) {
    this.$menu = $('.js-user-menu');
    this.$menuContainer = $('.js-user-menu-container');
    this.$help = $('.js-help-content');
    this.guia = guia;
    this.menuWidth = 180;
  }

  showMenu() {
    if (this.$menu.length && !this.$menu.hasClass('open')) {
      this.$menu.addClass('open');

      if (ScreenUtils.smOrSmaller()) {
        const menuHeight = $(window).height();

        this.$menu
          .removeClass('hide')
          .css({
            height: menuHeight,
            marginRight: `-${this.menuWidth}px`,
            maxHeight: menuHeight - this.$menu.offset().top,
            width: this.menuWidth,
          })
          .animate({
            marginRight: 0,
          }, 200);

        $('body')
          .bind('touchmove', event => event.preventDefault())
          .addClass('stop-scrolling');
      } else {
        this.$menuContainer.popover('show');
      }

      setTimeout(() => {
        $(window).one('click', this.hideMenu.bind(this));
      }, 250);
    }

    $('.js-queropago-menu-link').off('click');
    $('.js-queropago-menu-link').on('click', () => {
      trackable.eventTracker.track(Metrics.Events.ClickedUserMenuQueroPagoLink, { path: document.location.pathname });
    });
  }

  hideMenu() {
    if (this.$menu.length && this.$menu.hasClass('open')) {
      this.$menu.removeClass('open');

      if (ScreenUtils.smOrSmaller()) {
        this.$menu.animate({
          marginRight: `-${this.menuWidth}px`,
        }, 200, () => {
          this.$menu.addClass('hide');
        });

        $('body')
          .unbind('touchmove')
          .removeClass('stop-scrolling');
      } else {
        this.$menuContainer.popover('hide');
      }
    }
  }

  showHelp() {
    const helpHeight = $(window).height();
    let helpWidth = $(window).width() * 0.81;

    if (helpWidth > 310) {
      helpWidth = 310;
    }

    const startLeft = this.guia ? helpWidth : -helpWidth;

    this.$help
      .removeClass('hide')
      .css({
        height: helpHeight,
        marginLeft: startLeft,
        maxHeight: helpHeight - this.$help.offset().top,
        width: helpWidth,
      })
      .animate({
        marginLeft: 0,
      }, 200);

    $('body')
      .bind('touchmove', event => event.preventDefault())
      .addClass('stop-scrolling');

    setTimeout(() => {
      $(window).one('click', this.hideHelp.bind(this));
    }, 250);
  }

  hideHelp() {
    let helpWidth = $(window).width() * 0.8;

    if (helpWidth > 310) {
      helpWidth = 310;
    }

    const endLeft = this.guia ? helpWidth : -helpWidth;

    this.$help.animate({
      marginLeft: `${endLeft}px`,
    }, 200, () => {
      this.$help.addClass('hide');
    });

    $('body')
      .unbind('touchmove')
      .removeClass('stop-scrolling');
  }

  helpIsHidden() {
    return this.$help.hasClass('hide');
  }
}

export default Menu;
